import { OrderStatus } from '__generated__/atlas-types'

import { StatusDropdownIds } from '../../review.ids'

type Options = {
  defaultOptionId: string | null
  optionIds: string[]
}

type OptionsByOrderStatus = {
  [key in OrderStatus]?: Options
}

const optionsByOrderStatusLiteRetailer: OptionsByOrderStatus = {
  [OrderStatus.IN_PROGRESS]: {
    defaultOptionId: StatusDropdownIds.Share,
    optionIds: [
      StatusDropdownIds.Share,
      StatusDropdownIds.SubmitForApproval,
      StatusDropdownIds.CancelOrder,
    ],
  },
  [OrderStatus.NOTES]: {
    defaultOptionId: StatusDropdownIds.SubmitForApproval,
    optionIds: [
      StatusDropdownIds.SubmitForApproval,
      StatusDropdownIds.CancelOrder,
    ],
  },
  [OrderStatus.PENDING]: {
    defaultOptionId: StatusDropdownIds.EditOrder,
    optionIds: [],
  },
  [OrderStatus.APPROVED]: {
    defaultOptionId: StatusDropdownIds.PayNow,
    optionIds: [StatusDropdownIds.DuplicateOrder],
  },
  [OrderStatus.SHIPPED]: {
    defaultOptionId: StatusDropdownIds.DuplicateOrder,
    optionIds: [],
  },
  [OrderStatus.CANCELLED]: {
    defaultOptionId: StatusDropdownIds.DuplicateOrder,
    optionIds: [],
  },
}

const getOptionsByOrderStatusProBrands = (
  isUserApproveOrderRestricted = true,
  isOrphan = false,
  hasRemainingBalance = false,
  joorPayUseReach = false,
): OptionsByOrderStatus => ({
  [OrderStatus.IN_PROGRESS]: {
    defaultOptionId: StatusDropdownIds.Share,
    optionIds: [
      StatusDropdownIds.Share,
      StatusDropdownIds.Approve,
      StatusDropdownIds.SetToPending,
      StatusDropdownIds.MarkAsShipped,
      StatusDropdownIds.CancelOrder,
    ],
  },
  [OrderStatus.NOTES]: {
    defaultOptionId: isUserApproveOrderRestricted
      ? StatusDropdownIds.SetToPending
      : StatusDropdownIds.Approve,
    optionIds: isUserApproveOrderRestricted
      ? [StatusDropdownIds.SetToPending, StatusDropdownIds.CancelOrder]
      : [
          StatusDropdownIds.SetToPending,
          StatusDropdownIds.Approve,
          StatusDropdownIds.MarkAsShipped,
          StatusDropdownIds.CancelOrder,
        ],
  },
  [OrderStatus.PENDING]: {
    defaultOptionId: isUserApproveOrderRestricted
      ? StatusDropdownIds.SetToNotes
      : StatusDropdownIds.Approve,
    optionIds: isUserApproveOrderRestricted
      ? [StatusDropdownIds.SetToNotes, StatusDropdownIds.CancelOrder]
      : [
          StatusDropdownIds.SetToNotes,
          StatusDropdownIds.Approve,
          StatusDropdownIds.MarkAsShipped,
          StatusDropdownIds.CancelOrder,
        ],
  },
  [OrderStatus.APPROVED]: {
    defaultOptionId:
      isOrphan || !joorPayUseReach || !hasRemainingBalance
        ? StatusDropdownIds.MarkAsShipped
        : StatusDropdownIds.RequestPayment,
    optionIds: [
      ...(!isOrphan && joorPayUseReach && hasRemainingBalance
        ? [StatusDropdownIds.RequestPayment]
        : []),
      StatusDropdownIds.MarkAsShipped,
      StatusDropdownIds.SetToNotes,
      StatusDropdownIds.SetToPending,
      StatusDropdownIds.CancelOrder,
    ],
  },
  [OrderStatus.SHIPPED]: {
    defaultOptionId: StatusDropdownIds.DuplicateOrder,
    optionIds: [
      StatusDropdownIds.DuplicateOrder,
      StatusDropdownIds.SetToNotes,
      StatusDropdownIds.SetToPending,
      StatusDropdownIds.CancelOrder,
    ],
  },
  [OrderStatus.CANCELLED]: {
    defaultOptionId: StatusDropdownIds.DuplicateOrder,
    optionIds: [],
  },
})

const defaultOptionsValue: Options = {
  defaultOptionId: null,
  optionIds: [] as string[],
}

export const getOptionsByOrderStatus = (
  status: OrderStatus,
  isUserApproveOrderRestricted: boolean = true,
  isBrand: boolean = false,
  isOrphan: boolean = false,
  hasRemainingBalance: boolean = false,
  joorPayUseReach: boolean = false,
): Options => {
  const optionsByOrderStatus = isBrand
    ? getOptionsByOrderStatusProBrands(
        isUserApproveOrderRestricted,
        isOrphan,
        hasRemainingBalance,
        joorPayUseReach,
      )
    : optionsByOrderStatusLiteRetailer

  return optionsByOrderStatus[status] || defaultOptionsValue
}
